module.exports = __webpack_public_path__ + "img/web-mail.6a9e1e8f.svg";